import {useState} from 'react'

import Style from './style'
import FilterModal from './ui/FilterModal'
import filter from './asset/filter.svg'
import info from './asset/info.svg'

import fomular from 'shared/assets/ranking/formula.png'
import ranking from 'shared/assets/ranking/ranking.png'
import BgImage from 'shared/assets/background/ranking-background.png'

import RankingInfo from '../RankingInfo'

import Pagenation from 'widget/Pagenation'

import useGetRankingList from 'entity/ranking/useGetRankingList'
import useGetMyRanking from 'entity/ranking/useGetMyRanking'

import convertTier from 'shared/lib/convertTier'
import convertMoney from 'shared/lib/convertMoney'
import useLoginCookie from 'shared/model/useLoginCookie'
import {RANKING_FILTER_SORT_BY} from 'shared/constant/ranking'
import useQueryParams from 'shared/hooks/useQueryParams'
import convertTierIcon from 'shared/lib/convertTierIcon'

const Ranking = () => {
	const {getParam} = useQueryParams()
	const sortByType = getParam('level') || '2'
	const [isFilterShow, setIsFilterShow] = useState(false)
	const [isInfoShow, setIsInfoShow] = useState(false)

	const [rankingList] = useGetRankingList()
	const [myRanking] = useGetMyRanking() // 로그인이 된 경우에만 실행됨
	const [loginCookie] = useLoginCookie()

	// const tmp = [
	//     {
	//         "nickname": "김남길",
	//         "rank": "1",
	//         "total_score": "2566"
	//     },
	//     {
	//         "nickname": "김수현",
	//         "rank": "2",
	//         "total_score": "2147"
	//     },
	//     {
	//         "nickname": "조세호",
	//         "rank": "3",
	//         "total_score": "1890"
	//     },
	//     {
	//         "nickname": "염정원",
	//         "rank": "4",
	//         "total_score": "1876"
	//     },
	//     {
	//         "nickname": "안유진",
	//         "rank": "5",
	//         "total_score": "1645"
	//     },
	//     {
	//         "nickname": "임창정",
	//         "rank": "6",
	//         "total_score": "1414"
	//     },
	//     {
	//         "nickname": "정혜승",
	//         "rank": "7",
	//         "total_score": "998"
	//     },
	// ]

	return (
		<>
			{isInfoShow && <RankingInfo closeEvent={() => setIsInfoShow(false)} />}
			{isFilterShow && (
				<FilterModal closeEvent={() => setIsFilterShow((state) => !state)} />
			)}

			<div style={{display: 'none'}}>
				<img src={fomular} alt='preload-fomular' />
				<img src={ranking} alt='preload-ranking' />
				<img src={BgImage} alt='preload-bg' />
			</div>

			<Style.Wrapper>
				<Style.TitleDiv>
					<h2>랭킹</h2>
					<Style.TitleRight>
						<button
							className='filter-btn'
							onClick={() => setIsFilterShow(true)}
						>
							<p>
								{
									RANKING_FILTER_SORT_BY.find(
										(elem) => elem.value === sortByType
									)?.name
								}
							</p>
							<img src={filter} alt='filter' />
						</button>
						<Style.InfoBtn onClick={() => setIsInfoShow(true)}>
							<p>점수 산정 로직</p>
							<img src={info} alt='info' />
						</Style.InfoBtn>
					</Style.TitleRight>
				</Style.TitleDiv>

				<div>
					<Style.MyInfoDiv>
						{loginCookie ? (
							<>
								<Style.MyInfoElement $border>
									<h1>내 랭킹</h1>
								</Style.MyInfoElement>
								<Style.MyInfoElement>
									<h2>순위</h2>
									<p>{myRanking?.data?.rank || '순위권 외'}</p>
								</Style.MyInfoElement>
								<Style.MyInfoElement>
									<h2>티어</h2>
									<Style.TierWrapper>
										{convertTierIcon(myRanking?.data?.score) && (
											<img
												alt='icon'
												src={convertTierIcon(myRanking?.data?.score)}
												style={{
													width: '20px',
													height: '20px',
												}}
											/>
										)}
										<Style.MyTier $tier={convertTier(myRanking?.data?.score)}>
											{convertTier(myRanking?.data?.score)}
										</Style.MyTier>
									</Style.TierWrapper>
								</Style.MyInfoElement>
								<Style.MyInfoElement>
									<h2>시즌 점수</h2>
									<p>
										{myRanking?.data?.score
											? convertMoney(myRanking?.data?.score)
											: '0'}
									</p>
								</Style.MyInfoElement>
							</>
						) : (
							<Style.Caution>로그인을 해주세요.</Style.Caution>
						)}
					</Style.MyInfoDiv>

					<Style.RankingList>
						{rankingList?.data?.ranking_list?.map((elem, index) => (
							<Style.RankingElement>
								<Style.Rank $upper={parseInt(elem?.rank) < 4}>
									{elem?.rank}등
								</Style.Rank>
								<Style.Name $upper={parseInt(elem?.rank) < 4}>
									{elem?.nickname}
								</Style.Name>
								<Style.Tier $tier={convertTier(elem?.score)}>
									<Style.TierWrapper>
										{convertTierIcon(elem?.score) && (
											<img alt='icon' src={convertTierIcon(elem?.score)} />
										)}
										<p>{convertTier(elem?.score)}</p>
									</Style.TierWrapper>
								</Style.Tier>
								<Style.Info $upper={parseInt(elem?.rank) < 4}>
									{convertMoney(elem?.score)} PR
								</Style.Info>
							</Style.RankingElement>
						))}
						{rankingList?.data?.ranking_list?.length < 1 && (
							<Style.Option>이번 시즌의 랭킹 정보가 없습니다.</Style.Option>
						)}
					</Style.RankingList>
				</div>

				<Pagenation maxPage={rankingList?.data?.max_page} />
			</Style.Wrapper>
		</>
	)
}

export default Ranking
